import store from '@/store'
import { postData } from '@core/utils/http/general'

export default requestData => {
  const data = new FormData()
  data.append('origin', process.env.VUE_APP_ORIGIN_API)
  data.append('token', store.state.cuenta.session.token)

  Object.entries(requestData).forEach(element => { data.append(element[0], element[1]) })

  return new Promise((resolve, reject) => {
    postData(data)
      .then(response => {
        if (response.status === 200 && response.data.status === 200) resolve(response.data)
        else reject(response.data.message)
      })
      .catch(err => { reject(err) })
  })
}
